module.exports = __webpack_public_path__ + "static/storybook-supports-e20b6e7d31aac2c6e412feb9b2530d3b.png";